import standalone from '../../../../icons/standalone.png'
import { Box, Chip, Typography } from '@mui/material'
import { useTriConnection } from './hooks'
import { useAuthForm } from '../../../Auth/hooks';

interface StatusData {
  ha_state: string;
  active2standby_connection_alive: boolean;
  standby2observer_connection_alive: boolean;
  replica_seconds_behind: number | null;
}

const StandbyComponent = () => {

  const { data, isLoading, error, } = useTriConnection()
  const { statusData, statusError } = useAuthForm()

  const secondaryServer = data?.secondary_address === data?.active_server_address ? data?.primary_address : data?.secondary_address

  const boxDimensions = {
    width: { xs: 170, sm: 190, md: 210, lg: 230, xl: 250, },
    height: { xs: 150, sm: 160, md: 170, lg: 180, xl: 190, },
  };

  const ChipComponent = ({ statusData }: { statusData?: StatusData }) => {
    let label = '';
    let color: 'error' | 'default' | 'success' = 'default';

    if (statusData?.active2standby_connection_alive === false) {
      label = "Standby Disconnected";
    } else if (statusData?.standby2observer_connection_alive === false) {
      label = "Standby Degraded";
      color = "error";
    } else if (statusData?.replica_seconds_behind === null) {
      label = "Standby out of sync";
    } else if ((statusData?.replica_seconds_behind || 0) < 0) {
      label = "Resynchronizing";
    } else if (statusData?.active2standby_connection_alive) {
      label = "Standby Ready";
      color = "success";
    }

    return (
      <Chip label={label} color={color} />
    );
  };

  return (
    <>
      <Box
        id="standalone-box"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: boxDimensions.width,
          height: boxDimensions.height,
          justifyContent: 'center',
          backgroundColor: 'var(--card)',
          boxShadow: 3,
          borderRadius: 4,
          padding: 2,
        }}
      >
        <img src={standalone} alt="Standalone" style={{ width: "2rem", height: "2rem" }} />
        <Typography sx={{ mt: 1 }}>{data?.secondary_address !== data?.active_server_address ? 'Secondary' : 'Primary'}</Typography>
        <Typography sx={{ mt: 1 }}>{secondaryServer}</Typography>
        <Box>
          {/* <Chip label="Ready" color="default" /> */}
          {statusData ? <ChipComponent statusData={statusData} /> : <Chip label="Loading..." />}
        </Box>
        <Box>
          {/* <Typography>Active for 30d 12h</Typography> */}
        </Box>
      </Box>
    </>)
}

export default StandbyComponent